import React from 'react'
import Header from '../../../home/Header'
import Footer from '../../Footer'
import PrivacyPolicy from './PrivacyPolicy'

export default function index() {
  return (
    <div>
        <Header/>
        <PrivacyPolicy/>
        <Footer/>
    </div>
  )
}
